import { useRef, useState } from "react";
import Select from "../../../../../components/common/Select";
import useOutsideClick from "../../../../../hooks/useOutsideClick";
import WatermarkPreview from "../WatermarkPreview";

const WatermarkPreset = ({
  selectedWatermark = {},
  watermarkPresets,
  updateWatermark,
  removeWatermark,
}) => {
  const [selectedWatermarkPreset, setSelectedWatermarkPreset] = useState(false);

  const waterMarkDropDownContainer = useRef();

  const toggleWaterPreset = () => setSelectedWatermarkPreset((prev) => !prev);

  useOutsideClick(waterMarkDropDownContainer, () =>
    setSelectedWatermarkPreset(false)
  );

  return (
    <div className="relative max-w-[28rem]" ref={waterMarkDropDownContainer}>
      <Select
        onClick={() => toggleWaterPreset()}
        text={selectedWatermark.title}
        className="mt-4"
        isOpen={selectedWatermarkPreset}
      />

      {
        <div className="absolute w-full rounded-[10px] overflow-hidden bg-dark-gray shadow-card z-40 right-15 mt-3 top-[99%]">
          <div className="flex select-none flex-col text-light-gray text-sm">
            {selectedWatermarkPreset && (
              <div className="h-[200px] overflow-auto">
                {watermarkPresets.map(function (preset, key) {
                  let { id, title } = preset;

                  return (
                    <div
                      key={id}
                      onClick={() => {
                        updateWatermark(id, selectedWatermark.id);
                        toggleWaterPreset();
                      }}
                      className="cursor-pointer group capitalize px-4 py-3 hover:bg-black hover:text-primary-green"
                    >
                      <div className="invisible group-hover:visible">
                        <WatermarkPreview watermark={preset} />
                      </div>
                      {title}
                    </div>
                  );
                })}
              </div>
            )}
            {selectedWatermarkPreset && (
              <div
                onClick={() => {
                  removeWatermark(selectedWatermark.id);
                  toggleWaterPreset();
                }}
                className="cursor-pointer px-4 py-3 capitalize hover:bg-black hover:text-primary-error-red border-t-2 border-zinc-700 hover:bg-black"
              >
                Remove Watermark
              </div>
            )}
          </div>
        </div>
      }
    </div>
  );
};

export default WatermarkPreset;
